<template>
  <BaseSidebarDrawer v-model="localModelValue" width="408" overlay rounded-left>
    <div class="w-full h-full relative">
      <div class="flex items-center gap-3 sticky top-0 !text-blue-dark-500 bg-white border-b px-5 py-[18px] md:!p-6">
        <BaseIcon icon="arrow-forward" class="cursor-pointer" @click="localModelValue = false" />
        <span class="font-bold text-sm">مشاهده حساب کاربری</span>
      </div>
      <div class="overflow-y-auto no-scrollbar overscroll-none">
        <div class="pt-6 pb-8 px-5 md:px-6 border-b">
          <div class="flex items-center gap-2.5 text-blue-dark-500">
            <div class="w-6 h-6 grid place-items-center text-sm rounded bg-blue-dark-50">1</div>
            <span class="text-xs hidden md:inline">ابتدا از نوار بالای سایت، نشان پروفایل را انتخاب کنید.</span>
            <span class="text-xs inline md:hidden">ابتدا از نوار پایین، گزینه بیشتر را انتخاب کنید.</span>
          </div>
          <img src="~@/assets/images/support/show-accounts-1.webp" class="w-full h-[206px] hidden md:block object-contain mt-4" />
          <img src="~@/assets/images/support/mobile-more-menu.webp" class="w-full h-[245px] block md:hidden object-cover border rounded-lg mt-4" />
        </div>
        <div class="pt-6 pb-8 px-5 md:px-6 border-b">
          <div class="flex items-center gap-2.5 text-blue-dark-500">
            <div class="w-6 h-6 grid place-items-center text-sm rounded bg-blue-dark-50">2</div>
            <span class="text-xs hidden md:inline">پس از آن، با کلیک روی نام خود، وارد صفحه حساب کاربری شوید.</span>
            <span class="text-xs inline md:hidden">با ضربه زدن روی نام خود، وارد صفحه حساب کاربری شوید.</span>
          </div>
          <img src="~@/assets/images/support/show-accounts-2.webp" class="w-full h-[206px] hidden md:block object-contain mt-4" />
          <img
            src="~@/assets/images/support/mobile-show-accounts-1.webp"
            class="w-full h-[245px] block md:hidden object-cover border rounded-lg mt-4"
          />
        </div>
        <div class="pt-6 pb-8 px-5 md:px-6 border-b">
          <div class="flex gap-2.5 text-blue-dark-500">
            <div class="w-6 h-6 flex-shrink-0 grid place-items-center text-sm rounded bg-blue-dark-50">3</div>
            <span class="text-xs leading-5">با ورود به حساب کاربری، می‌توانید به امکانات زیر دسترسی داشته باشید:</span>
          </div>
          <div class="flex flex-col gap-2 pr-3 mt-2.5">
            <div class="flex items-center gap-2">
              <div class="w-1 h-1 bg-blue-dark-400 rounded-full"></div>
              <span class="text-xs text-blue-dark-400">مدیریت اطلاعات حساب کاربری</span>
            </div>
            <div class="flex items-center gap-2">
              <div class="w-1 h-1 bg-blue-dark-400 rounded-full"></div>
              <span class="text-xs text-blue-dark-400">ایجاد حساب حقوقی</span>
            </div>
            <div class="flex items-center gap-2">
              <div class="w-1 h-1 bg-blue-dark-400 rounded-full"></div>
              <span class="text-xs text-blue-dark-400">مشاهده و مدیریت نشست‌های فعال در دستگاه‌های شما</span>
            </div>
            <div class="flex items-center gap-2">
              <div class="w-1 h-1 bg-blue-dark-400 rounded-full"></div>
              <span class="text-xs text-blue-dark-400">مدیریت آدرس‌ها و گیرنده‌های سفارش‌ها</span>
            </div>
            <div class="flex items-center gap-2">
              <div class="w-1 h-1 bg-blue-dark-400 rounded-full"></div>
              <span class="text-xs text-blue-dark-400">انجام فرآیند احراز هویت در صورت نیاز</span>
            </div>
            <div class="flex items-center gap-2">
              <div class="w-1 h-1 bg-blue-dark-400 rounded-full"></div>
              <span class="text-xs text-blue-dark-400">استفاده از سایر قابلیت‌های پنل کاربری</span>
            </div>
          </div>
          <img src="~@/assets/images/support/show-accounts-3.webp" class="w-full h-[206px] hidden md:block object-contain mt-4" />
          <img
            src="~@/assets/images/support/mobile-show-accounts-2.webp"
            class="w-full h-[245px] block md:hidden object-cover border rounded-lg mt-4"
          />
        </div>
      </div>
    </div>
  </BaseSidebarDrawer>
</template>

<script setup lang="ts">
import BaseSidebarDrawer from "@/components/base/BaseSidebarDrawer.vue";
import { computed } from "vue";

const props = defineProps({
  modelValue: {
    type: Boolean,
    default: false,
  },
});

const emit = defineEmits(["update:modelValue"]);

const localModelValue = computed({
  get() {
    return props.modelValue;
  },
  set(value) {
    emit("update:modelValue", value);
  },
});
</script>

<style scoped></style>
